const theme = {
  roboto: "'Roboto Mono', monospace",
  lora: "'Lora', serif"
}

export default theme
